import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';
import { showError } from '../../utils/Utils';

export const createWriteOffSecond = async (data) => {
    try {
        const createResp = await authAxiosInstance.post(
            '/writeOffSecond',
            data
        );
        return createResp;
    } catch (error) {
        console.log(error);
        toast.error('failed to create cutting card');
    }
};

export const fetchWriteOffSecond = async (data) => {
    try {
        console.log('fetching cutting cards');
        const string = QueryString.stringify(data);
        const receiveResp = await authAxiosInstance.get(
            `/writeOffSecond?${string}`
        );
        return receiveResp.data;
    } catch (error) {
        console.log(error);
        toast.error('failed to fetch Cutting Cards');
    }
};

export const deleteWriteOffSecond = async (id) => {
    try {
        const deleteResp = await authAxiosInstance.delete(
            `/writeOffSecond/${id}`
        );
        return deleteResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
